module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.BillingFrequencyDays === 0) {
            switch (deliverySaverPlan.BillingFrequencyMonths) {
                case 1: return 'Monthly Subscription';
                case 12: return 'Annual Subscription';
            }
        } else if (deliverySaverPlan.BillingFrequencyMonths === 0) {
            switch (deliverySaverPlan.BillingFrequencyDays) {
                case 1: return 'Daily Subscription';
                case 7: return 'Weekly Subscription';
            }
        }
        return deliverySaverPlan.Name;
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-short-name.filter.js